<div class="check">
  <span>{{ off }}</span>
  <label class="wrap-switch">
    <input
      type="checkbox"
      [id]="id"
      class="checkbox"
      [formControl]="control"
      [checked]="checked"
      hidden
    />
    <span class="toggle"></span>
  </label>
  <span>{{ on }}</span>
</div>
